define("shared/utils/file", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getImageFromFile = getImageFromFile;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Return a HTMLImageElement from a File with image MimeType
   */
  function getImageFromFile(file) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        resolve(img);
        URL.revokeObjectURL(img.src);
      };
      img.onerror = () => {
        reject(new Error('Image could not be loaded'));
      };
      const objectURL = window.URL.createObjectURL(file);
      img.src = objectURL;
    });
  }
});